// import React from "react";
// import "./WhatsAppButton.css";

// const WhatsAppButton = () => {
//   const phoneNumber = "919925534220"; // Apna number (country code ke sath)
//   const message = "Hello! I am interested in your services";

//   // https://web.whatsapp.com/send?phone=+919974183382&text=%20hi

//   const whatsappLink = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
//     message
//   )}`;

//   return (
//     <a
//       href={whatsappLink}
//       target="_blank"
//       rel="noopener noreferrer"
//       className="whatsapp-float-button"
//     >
//       <img src="/whatsapp.png" alt="WhatsApp" className="whatsapp-icon" />
//     </a>
//   );
// };

// export default WhatsAppButton;
import React, { useState } from "react";
import {
  Box,
  IconButton,
  Avatar,
  Typography,
  TextField,
  Button,
  Paper,
  Slide,
} from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import CloseIcon from "@mui/icons-material/Close";
import { WhatsApp } from "@mui/icons-material";
import AvtarImg from "../images/MRproductFavicon.png";

const WhatsAppButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [userMessage, setUserMessage] = useState("");

  const phoneNumber = "919925534220";
  const defaultMessage = "Hello! How can I help you?";

  const handleSend = () => {
    const message = userMessage;
    const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
      message
    )}`;
    // const whatsappLink = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
    //   message
    // )}`;
    window.open(whatsappLink, "_blank");
    setIsOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20,
          bgcolor: "#25D366",
          width: 60,
          height: 60,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
          cursor: "pointer",
        }}
        onClick={() => (!isOpen ? setIsOpen(true) : handleSend())}
      >
        {/* <ChatIcon sx={{ color: "white", fontSize: 32 }} /> */}
        <WhatsApp sx={{ color: "white", fontSize: 40 }} />
      </Box>

      <Slide direction="up" in={isOpen} mountOnEnter unmountOnExit>
        <Paper
          elevation={4}
          sx={{
            position: "fixed",
            bottom: 90,
            right: 20,
            width: 300,
            borderRadius: 3,
            overflow: "hidden",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              bgcolor: "#075E54",
              color: "white",
              p: 1.5,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Avatar src={AvtarImg} sx={{ mr: 1 }} />
            <Box>
              <Typography variant="subtitle1">MR Products</Typography>
              <Typography variant="caption">
                Typically replies within a day
              </Typography>
            </Box>
            <IconButton
              sx={{ ml: "auto", color: "white" }}
              onClick={() => {
                setIsOpen(false);
                setUserMessage("");
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ bgcolor: "#e5ddd5", p: 2 }}>
            <Paper sx={{ p: 1, bgcolor: "white", display: "inline-block" }}>
              <Typography variant="body2" color={"#333333ff"}>
                {defaultMessage}
              </Typography>
            </Paper>
            <Typography
              variant="caption"
              sx={{ display: "block", mt: 0.5, color: "gray" }}
            >
              {new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              p: 1,
              borderTop: "1px solid #ddd",
            }}
          >
            <TextField
              variant="outlined"
              size="small"
              placeholder="Type a message"
              value={userMessage}
              onChange={(e) => setUserMessage(e.target.value)}
              sx={{ flex: 1, mr: 1, bgcolor: "#f0f0f0", borderRadius: "20px" }}
            />
            <Button
              variant="contained"
              sx={{
                bgcolor: "#25D366",
                textTransform: "none",
                borderRadius: "20px",
                "&:hover": {
                  bgcolor: "#128C7E",
                },
              }}
              onClick={handleSend}
            >
              Send
            </Button>
          </Box>
        </Paper>
      </Slide>
    </>
  );
};

export default WhatsAppButton;
